const alertData = {
  warning: "warning-important",
  info: "info",
  danger: "error-severe",
  success: "checked",
};

export default alertData;
